export enum AssignmentOnReply {
  noAssign = 0,
  assignOnCompose = 1,
  assignOnReply = 2,
  assignOnBoth = 3,
}
